import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-dashboard-help',
    templateUrl: './dashboard-help.component.html'
})
export class DashboardHelpComponent {
}
